import { Component, OnInit } from '@angular/core';
import { Funds_Interface } from 'src/app/Interface/Funds_Interface';
import { LetterRequestCustomer_Funds_Interface } from 'src/app/Interface/LetterRequestCustomer_Funds_Interface';
import { FundsService } from 'src/app/Service/Funds/Funds.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-FundsSettle',
  templateUrl: './FundsSettle.component.html',
  styleUrls: ['./FundsSettle.component.scss']
})
export class FundsSettleComponent implements OnInit {

  Token:String=""
  InProccessing: boolean = false
  page_Charge: any
  page_Pay: any
  BaseUrl = environment.BaseUrl
  SubmitPeriodDate: string = '0'

  Filter_Price_Giver: string = ""
  Filter_Dsc: string = ""

  DataList_Funds_Charge: Array<Funds_Interface> = []
  DataList_Funds_Charge_Price:number=0

  constructor(
    private Funds_Service: FundsService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1168).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }


  ReadData_Funds(StartSearchDate,EndSearchDate) {
    this.InProccessing = true
    this.Funds_Service.GetFundsSettle(this.Token,
      StartSearchDate,
      EndSearchDate,
      Number(this.SubmitPeriodDate)).subscribe(
      data => {
          this.DataList_Funds_Charge = data['result']
          this.DataList_Funds_Charge_Price = data['total']


        this.InProccessing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "DaroFunds.xlsx");

  }
}
